import type { AsyncState } from '@essent/common';
import { createAsyncStateReducer } from '@essent/common';
import type {
  GetReviewsResponseWithStatistics,
  GetReviewStatisticsResponse,
} from '@integration/reviews-api-models';

import { getReviewsActions, getReviewStatisticsActions } from '../actions';

export const reviewsFeatureSelectorKey = 'reviews';
export const reviewsSelectorKey = 'reviews';
export const statsSelectorKey = 'stats';

export type ReviewsState = AsyncState<GetReviewsResponseWithStatistics>;
export type StatsState = AsyncState<GetReviewStatisticsResponse>;

export interface ReviewsFeatureState {
  [reviewsSelectorKey]: ReviewsState;
  [statsSelectorKey]: StatsState;
}

export const reviewsReducers = {
  [reviewsSelectorKey]: createAsyncStateReducer(getReviewsActions),
  [statsSelectorKey]: createAsyncStateReducer(getReviewStatisticsActions),
};
